<template>
  <v-card class="requests-panel" rounded="xl" elevation="0">
    <div class="requests-panel__header">
      <div class="d-flex align-center">
        <v-icon color="#b45309" class="mr-2">mdi-account-clock-outline</v-icon>
        <div>
          <div class="requests-panel__title">
            {{ requests.length }} solicitação{{
              requests.length === 1 ? "" : "ões"
            }}
            aguardando
          </div>
          <div class="requests-panel__subtitle">
            Aceite ou recuse os alunos que pediram para entrar nesta turma.
          </div>
        </div>
      </div>
    </div>

    <v-row dense class="mt-2">
      <v-col v-for="student in requests" :key="student.id" cols="12" md="6">
        <class-member-card
          :student="student"
          :theme="theme"
          :normalized-times="normalizedTimes"
          :class-days="classDays"
          show-actions
          @reload="$emit('reload')"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ClassMemberCard from "@/components/classes/ClassMemberCard.vue";

export default {
  name: "ClassRequestsPanel",

  components: {
    ClassMemberCard,
  },

  props: {
    requests: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: Object,
      required: true,
    },
    normalizedTimes: {
      type: Array,
      default: () => [],
    },
    classDays: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.requests-panel {
  padding: 18px 20px 8px;
  border: 1px solid rgba(245, 158, 11, 0.35);
  background: linear-gradient(
    180deg,
    rgba(255, 251, 235, 0.95) 0%,
    rgba(255, 255, 255, 0.98) 100%
  );
}

.requests-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.requests-panel__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #92400e;
}

.requests-panel__subtitle {
  font-size: 0.88rem;
  color: rgba(120, 53, 15, 0.8);
  margin-top: 2px;
}
</style>
